import { Component, Prop, Vue } from 'vue-property-decorator';
import { formatDateToDisplay } from '@/helpers';
import { MemberPeerEvaluationDTO, UserEngagementDTO } from '@/models';
import { getReceivedDropsFromProjectPEs } from '@/services';

interface AdjustHistoryDTO {
  date: string;
  pic: string;
  description: string;
  comments: string;
}

@Component
export default class ViewEditHistory extends Vue {
  @Prop({ default: () => [] }) peerEvaluations: MemberPeerEvaluationDTO[];
  @Prop() userEngagement: UserEngagementDTO;

  private tableHeaderColumns = [
    {
      text: 'Date',
      value: 'date',
      class: 'grey--text'
    },
    {
      text: 'PIC',
      value: 'pic',
      class: 'grey--text'
    },
    {
      text: 'Description',
      value: 'description',
      class: 'grey--text'
    },
    {
      text: 'Comments',
      value: 'comments',
      class: 'grey--text'
    }
  ];
  private originalDate = '';

  get buildAdjustHistoryData(): AdjustHistoryDTO[] {
    const {
      adjustedBy,
      adjustedDrops,
      contributionDrops,
      givingDrops,
      individualDrops,
      reasonForAdjustment,
      updatedAt,
      user
    } = this.userEngagement;

    const originalIndividualDrops =
      contributionDrops - givingDrops + getReceivedDropsFromProjectPEs(user.id, this.peerEvaluations);

    const original = {
      date: formatDateToDisplay(this.originalDate || ''),
      pic: 'System',
      description: `The original number of Individual Pollens is ${originalIndividualDrops} pollens`,
      comments: 'N/A'
    };

    if (this.userEngagement.adjustedDrops > 0) {
      const adjustedIndividualDrops = contributionDrops - givingDrops + adjustedDrops;

      const adjusted = {
        date: formatDateToDisplay(updatedAt || ''),
        pic: adjustedBy || 'System',
        description: `The number of Total Received Pollens was changed to ${adjustedDrops} pollens. 
        The number of Individual Pollens is now ${individualDrops || adjustedIndividualDrops} pollens.`,
        comments: reasonForAdjustment
      };

      return [original, adjusted];
    }

    return [original];
  }

  created(): void {
    this.originalDate = [...this.peerEvaluations].pop()?.updatedAt || '';
  }

  onClose(): void {
    this.$emit('onClose');
  }
}
